export default __webpack_public_path__ + "static/media/ftm-logo.ee7b2f79.svg";